// 9fbef606107a605d69c0edbcd8029e5d

export const VARIANTS = {
  FILLED: "filled",
  UNDERLINE: "underline",
};
